import { MarketplaceTabGroup } from '../../../../../utils/tabGroupDividers';

export enum SellerMarketplaceTab {
    MyEngagement = 1,
    EngagementDocuments = 2,
    EngagementTimeline = 3,
    Buyers = 4,
    DeadlineDocket = 5,
    DataAndDocs = 6,
    Settings = 7,
    CommsHub = 8,
    EngagementHistory = 9,
    SellerProfile = 10,
    DataRoomLayout = 11,
    VDRAccess = 12,
    Lois = 13,
    FAQs = 14,
    LoiComparison = 15,
    FlowOfFunds = 16,
    TransactionDocuments = 17,
}

export const SellerMarketplaceTabs = [
    {
        id: SellerMarketplaceTab.MyEngagement,
        label: 'My Engagement',
        tooltip: 'Overview of your engagement status and key details.',
        group: MarketplaceTabGroup.Engagement,
    },
    {
        id: SellerMarketplaceTab.EngagementHistory,
        label: 'Engagement History',
        tooltip: 'Review the history and activity log of your engagement.',
        group: MarketplaceTabGroup.Engagement,
    },
    {
        id: SellerMarketplaceTab.FAQs,
        label: 'FAQs',
        group: MarketplaceTabGroup.Engagement,
    },
    {
        id: SellerMarketplaceTab.EngagementDocuments,
        label: 'Engagement Documents',
        tooltip: 'View and manage documents related to your engagement.',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: SellerMarketplaceTab.EngagementTimeline,
        label: 'Engagement Timeline',
        tooltip: 'Track milestones and progress of your engagement.',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: SellerMarketplaceTab.DeadlineDocket,
        label: 'Deadline Docket',
        tooltip: 'Track upcoming deadlines and action items.',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: SellerMarketplaceTab.DataAndDocs,
        label: 'Practice Data & Docs',
        tooltip: 'Access and manage practice data and documents.',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: SellerMarketplaceTab.SellerProfile,
        label: 'Seller Profile',
        tooltip: 'View and update your seller profile information.',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: SellerMarketplaceTab.Buyers,
        label: 'Buyers',
        tooltip: 'View and manage buyer activity and profiles.',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: SellerMarketplaceTab.CommsHub,
        label: 'Comms Hub',
        tooltip: 'Communicate with your advisory team and buyers.',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: SellerMarketplaceTab.LoiComparison,
        label: 'LOI Comparison',
        tooltip: 'Compare and review Letters of Intent from buyers.',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: SellerMarketplaceTab.DataRoomLayout,
        label: 'Data Room',
        tooltip: 'Manage and share documents in your secure data room.',
        group: MarketplaceTabGroup.ClosingAndBeyond,
    },
    {
        id: SellerMarketplaceTab.TransactionDocuments,
        label: 'Transaction Documents',
        group: MarketplaceTabGroup.ClosingAndBeyond,
    },
    {
        id: SellerMarketplaceTab.FlowOfFunds,
        label: 'Closing Flow of Funds',
        group: MarketplaceTabGroup.ClosingAndBeyond,
    },
    {
        id: SellerMarketplaceTab.Settings,
        label: 'Settings',
        group: MarketplaceTabGroup.Administration,
    },
    {
        id: SellerMarketplaceTab.VDRAccess,
        label: 'VDR Access',
        group: MarketplaceTabGroup.Administration,
    },
    {
        id: SellerMarketplaceTab.Lois,
        label: 'LOIs',
        group: MarketplaceTabGroup.Administration,
    },
];
